import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './polyfills';
import { Main } from './main';
import * as serviceWorker from './service-worker';

ReactDOM.render(<Main />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
